import React from 'react';
import { FadeIn } from './FadeIn';
export function Qualifier() {
  return <section className="py-16 sm:py-24 px-4 bg-running-dark border-y border-running-muted" data-id="element-162">
      <div className="max-w-3xl mx-auto text-center" data-id="element-163">
        <FadeIn data-id="element-164">
          <h2 className="text-2xl sm:text-3xl font-display font-bold text-white mb-8" data-id="element-165">
            Pero antes de decirte el precio, necesito ser honesto con vos.
          </h2>
          <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-166">
            <p data-id="element-167">
              Este pack <strong className="text-red-400" data-id="element-168">no es</strong> para el
              profe que quiere más PDFs para guardar en una carpeta.
            </p>
            <p data-id="element-169">
              Es para el profe que va a abrir el Tomo 1 esta semana y va a
              planificar el trimestre. Que va a integrar los ejercicios de
              fuerza en el plan de sus alumnos la próxima sesión. Que va a
              entregar el informe de recuperación al final del mes. Que va a
              usar el sistema de nutrición antes de la próxima carrera.
            </p>
            <p className="text-white font-bold text-xl mt-8" data-id="element-170">
              Si eso sos vos, este pack va a cambiar la forma en que trabajás.{' '}
              <br className="hidden sm:block" data-id="element-171" />
              <span className="text-running-blue" data-id="element-172">
                No en tres meses. En la primera semana.
              </span>
            </p>
            <p className="text-sm text-gray-500 mt-8 uppercase tracking-widest font-bold" data-id="element-173">
              Si no estás listo para usarlo, no te lo vendas a vos mismo. No es
              para juntar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}